export default "__VITE_ASSET__DevP_IJ5__"